import script from "./CtrlManifiesto.vue?vue&type=script&lang=ts&setup=true"
export * from "./CtrlManifiesto.vue?vue&type=script&lang=ts&setup=true"

import "./CtrlManifiesto.vue?vue&type=style&index=0&id=1fdb8bae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fdb8bae"]])

export default __exports__